import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { toast } from "react-toastify";
import { updateCompanyProfile } from "../../utils/api/company";

function CompanyEditModal({ admin, closeModal, setRefresh }) {
  const dispatch = useDispatch();

  const [adminFields, setAdminFields] = useState({
    name: "",
    email: "",
    apiUsername: "",
    apiPassword: "",
    formLink: "",
    isBypass: false,
    usedData: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (admin) {
      console.log(admin);
      setAdminFields({
        name: admin.name,
        email: admin.email,
        isBypass: admin.isBypass,
        apiUsername: admin.apiUsername || "",
        apiPassword: admin.apiPassword || "",
        formLink: admin.formLink || "",
        usedData: admin.usedData || "",
      });
    }
  }, [admin]);

  const handleInputChange = (field, value) => {
    setAdminFields((prevFields) => ({ ...prevFields, [field]: value }));
  };

  const handleSubmit = () => {
    const updatedAdmin = { ...adminFields };
    try {
      updateCompanyProfile(updatedAdmin, admin?.id)
        .then(({ data }) => {
          toast.success("Admin updated successfully!");
          setRefresh((refresh) => !refresh);
          closeModal(false);
          // console.log(data);
        })
        .catch((error) => {
          toast.error(
            `Error updating company: ${error?.response?.data?.error}`
          );
        });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-full max-w-lg p-6 bg-white rounded-lg shadow-lg">
        <h2 className="mb-4 text-xl font-semibold text-center">Edit Company</h2>

        <div className="mb-4">
          <input
            type="text"
            className="w-full p-3 my-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Client Name"
            value={adminFields.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
          />
          <input
            type="email"
            className="w-full p-3 my-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Client Email"
            value={adminFields.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
          />
          <input
            type="text"
            className="w-full p-3 my-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="API Username"
            value={adminFields.apiUsername}
            onChange={(e) => handleInputChange("apiUsername", e.target.value)}
          />
          <p
            onClick={() => setShowPassword(!showPassword)}
            className="pt-2 text-blue-600 underline cursor-pointer"
          >
            Change API Password
          </p>
          {showPassword && (
            <input
              type="password"
              className="w-full p-3 my-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter new API password"
              value={adminFields.apiPassword}
              onChange={(e) => handleInputChange("apiPassword", e.target.value)}
            />
          )}
          <input
            type="text"
            className="w-full p-3 my-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Form Link"
            value={adminFields.formLink}
            onChange={(e) => handleInputChange("formLink", e.target.value)}
          />
          <input
            type="text"
            className="w-full p-3 my-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Used Data"
            value={adminFields.usedData}
            onChange={(e) => handleInputChange("usedData", e.target.value)}
          />

        </div>
        <div className="mb-4 flex justify-start">
          <label>Bypass Form Response</label>
          <input
            type="checkbox"
            className="w-full p-3 my-2 rounded-md focus:outline-none"
            placeholder="Is Bypass"
            checked={adminFields.isBypass}
            onChange={(e) => handleInputChange("isBypass", e.target.checked)}
          />
        </div>
        <div className="flex justify-between space-x-4">
          <button
            type="button"
            onClick={() => closeModal(false)}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-500 transition duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            type="button"
            className="flex-1 px-4 py-2 text-sm font-medium text-white transition duration-200 bg-blue-600 rounded-lg hover:bg-blue-700"
            onClick={handleSubmit}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default CompanyEditModal;
